import { trim } from 'lodash';
import api from '../api';
import useCheckoutState from './useCheckoutState';

export default function useCheckoutCoupon() {
  const { checkout, seller, setCoupon } = useCheckoutState();

  async function validateCoupon(discountCode) {
    const code = trim(discountCode);

    const { data, error } = await api.validateCoupon({ code }, checkout._id, seller._id);

    if (data) {
      setCoupon(data);
    } else {
      throw new Error(error || 'Invalid coupon');
    }
  }

  async function getCouponByStripeCouponId(stripeCouponId) {
    const { data, error } = await api.getCouponByStripeCouponId(stripeCouponId, seller._id);

    if (data) {
      return data;
    } else {
      throw new Error(error || 'Invalid coupon');
    }
  }

  return {
    validateCoupon,
    getCouponByStripeCouponId,
  };
}
